import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Error, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { secondsToTime } from 'shared/lib/secondsToTime'
import { useTextToSpeechContext } from 'widgets/TextToSpeech/context/context'
import {
  type ITextToSpeechVoiceProps,
  TextToSpeechVoice,
} from 'widgets/TextToSpeech/ui/TextToSpeechVoice/TextToSpeechVoice'
import styles from './styles.module.scss'

export type ITextToSpeechInfoProps = {
  className?: string
  isErrorNotReplaceVoice?: boolean
} & ITextToSpeechVoiceProps

export const TextToSpeechInfo = observer(
  ({ className, customComponent, isErrorNotReplaceVoice }: ITextToSpeechInfoProps) => {
    const { duration, audioFileDuration, error, isErrorLength, isHideVoicesDropdown } =
      useTextToSpeechContext()
    return (
      <div>
        {isErrorNotReplaceVoice && error && (
          <div className={styles.wrapTopError}>
            <Error type={'text'} error={error} size={'medium'} />
          </div>
        )}
        <div aria-label={getAriaLabel('text')} className={classNames(styles.wrap, className)}>
          <div>
            {!isErrorNotReplaceVoice && error ? (
              <div className={styles.wrapError}>
                <Error type={'text'} error={error} size={'medium'} />
              </div>
            ) : isHideVoicesDropdown ? null : (
              <TextToSpeechVoice customComponent={customComponent} />
            )}
          </div>
          {!!duration && (
            <Typography
              ariaLabel={'duration'}
              className={classNames(styles.duration, { [styles.error]: isErrorLength })}
            >
              {(audioFileDuration && secondsToTime(audioFileDuration)) ||
                `~${secondsToTime(duration)}`}
            </Typography>
          )}
        </div>
      </div>
    )
  }
)
